import styled from "styled-components";
export const YachtWrapper = styled.div`
  background-color: #fff;
`;
